export const getKeyByValueFromEnumeration = (value: string, enumeration: Record<string|number, string|number>) => {
  const indexOfValue : number = Object.values(enumeration).indexOf(value);
  const key = Object.keys(enumeration)[indexOfValue];
  return key;
};
